export const locationConfigError = () => {
  throw new Error(
    "`getPropsFor` was provided with a " +
      "`location` argument which has not been configured." +
      "see `locationConfig.js` in the" +
      "`components/UnlockOrPreviewContentBanner` folder",
  );
};

export const componentConfigError = () => {
  throw new Error(
    "`getPropsFor` was provided with a " +
      "`component` argument which has not been configured." +
      "see `locationConfig.js` in the" +
      "`components/UnlockOrPreviewContentBanner` folder",
  );
};
